// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"db856271","232":"e963d480","307":"bbee1ee8","385":"aeaaa3bd","462":"8992bf5a","711":"3649dbfb","727":"dd88837a","787":"aadca95f","902":"20c39cde"}[chunkId] + ".chunk.js";
};